function isDraggable(visualElement) {
  var _a = visualElement.getProps(),
      drag = _a.drag,
      _dragX = _a._dragX;

  return drag && !_dragX;
}

export { isDraggable };